// Static release notes for LDCP-186 (hard-coded until CMS/API exists).
// Shape is intentionally simple so a future fetch/mapper can swap this module out.

export const RELEASE_NOTES = [
  {
    version: "2.6.0",
    name: "June Platform Update",
    date: "June 20, 2026",
    description:
      "This release brings a refreshed v2 help experience, tenant bug reporting from the top navigation, and continued improvements across API Security and WAF detection. Navigation and drawer patterns are now more consistent with the rest of the org dashboard, making it easier to find documentation, report issues, and review what changed between releases.",
    highlights: [
      "Improved v2 dashboard navigation and help menu",
      "Bug reporting from the top nav",
      "API Security and WAF detection updates",
    ],
  },
  {
    version: "2.5.0",
    name: "May Settings Release",
    date: "May 15, 2026",
    description:
      "Expanded v2 settings coverage for account, SSO, and organisation management, plus SSL/TLS workflow improvements.",
    highlights: [
      "New v2 settings pages for account, SSO, and organisation",
      "Enhanced SSL/TLS certificate management",
      "Performance improvements across detection event lists",
    ],
  },
  {
    version: "2.4.0",
    name: "April Security Release",
    date: "April 10, 2026",
    description:
      "Major updates to bot management configuration and API Security overview dashboards, alongside unified v2 page headers and typography tokens used across services and detection pages.",
    highlights: [
      "Bot management configuration redesign",
      "API Security overview and posture dashboards",
      "Unified v2 page headers and typography",
    ],
  },
];
